import React, { ReactElement } from 'react';

interface InfoCardProps {
    texts: Array<string>;
    img: string;
    customClass?: string;
}

const InfoCard = ({ texts, img, customClass }: InfoCardProps): ReactElement<'div'> | null => {
    return (
        <>
            <div className={'row otz-info-card ' + customClass}>
                {img && <img src={'../img/otz/info-card/' + img} alt={img} className={'otz-info-card-img'} />}
                <div className="otz-info-card-text">
                    {texts.map((text, i) => (
                        <p key={`ifc-${i}`} dangerouslySetInnerHTML={{ __html: text }} />
                    ))}
                </div>
            </div>
            <hr className={'otz-info-card-hr ' + customClass} />
        </>
    );
};

export default InfoCard;
